import { Event } from "../../contracts";
import { EventsBySportIdRequest } from "sb-resp-lib";

export const mapEventIcons = (x: Event) => {
    x.livestreamIcon = { active: checkAvailability(x.tags.indexOf(EventsBySportIdRequest.EventTagsEnum.LiveStreaming.toString())), tooltip: "LiveStream" };
    x.statisticsIcon = { active: checkAvailability(x.tags.indexOf(EventsBySportIdRequest.EventTagsEnum.Stats.toString())), tooltip: "Statistics" };
    x.fastmarketIcon = { active: checkAvailability(x.tags.indexOf(EventsBySportIdRequest.EventTagsEnum.FastMarket.toString())), tooltip: "FastMarket" };
    x.pulsebetIcon = { active: checkAvailability(x.tags.indexOf("Pulse")), tooltip: "PulseBet" };
    return x;
}

const checkAvailability = (index: number) => index === -1 ? false : true;